import { Trans } from '@lingui/macro'
import classNames from 'classnames'
import { FC } from 'react'

import useSeeMore from '../../../hooks/useSeeMore'
import { FeedObjectAnswer, FeedUserView } from '../../../interfaces'
import AnswerProfile from '../AnswerProfile'
import styles from './Answer.module.css'

interface Props {
  answer: FeedObjectAnswer
  profile?: FeedUserView
}

const Answer: FC<Props> = props => {
  const { isOpen, r, seeMore, setIsOpen } = useSeeMore()

  const profile = props.profile ? <AnswerProfile answer={props.answer} profile={props.profile} /> : null

  return (
    <>
      {profile}
      {props.answer.answerText?.value && (
        <div className={styles.wrapper}>
          <div className={classNames({ [styles.clamped]: !isOpen })} ref={r}>
            {props.answer.answerText?.value}
          </div>
          {seeMore && !isOpen ? (
            <span className={styles.link} onClick={() => setIsOpen(true)}>
              <Trans>Read More</Trans>
            </span>
          ) : null}
        </div>
      )}
    </>
  )
}

export default Answer
